import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AnimatedCursor from "react-animated-cursor";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		{/* <AnimatedCursor
			innerSize={0}
			outerSize={10}
			color="0, 0, 0"
			outerScale={20}
			showSystemCursor={true}
			outerAlpha={0}
			outerStyle={{
				backdropFilter: "invert(1)",
			}}
			clickables={[
				"a",
				'input[type="text"]',
				'input[type="email"]',
				'input[type="number"]',
				'input[type="submit"]',
				'input[type="image"]',
				"label[for]",
				"select",
				"textarea",
				"button",
				".link",
				"span",
			]}
		/> */}
		<App />
	</React.StrictMode>
);
